var AlertLooks = /*#__PURE__*/ function(AlertLooks) {
    AlertLooks["Error"] = "error";
    AlertLooks["None"] = "none";
    AlertLooks["Success"] = "success";
    AlertLooks["Warning"] = "warning";
    return AlertLooks;
}({});
var AlertTypes = /*#__PURE__*/ function(AlertTypes) {
    AlertTypes["Assertive"] = "assertive";
    AlertTypes["Polite"] = "polite";
    return AlertTypes;
}({});

export { AlertLooks, AlertTypes };
//# sourceMappingURL=alert.js.map
